import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingItemHeader: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  trainingWrapper: {},
  trainingForm: {
    '& > div:first-of-type': {
      marginTop: 0,
    },
  },
  trainingSetsContainer: {
    marginTop: theme.spacing(1),
  },
  trainingSetWrapper: {
    borderRadius: '10px',
    marginTop: theme.spacing(1),
  },
  trainingFooter: {
    padding: `${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(1)}`,
  },
  addTrainingSetFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    padding: `${theme.spacing(1)} ${theme.spacing(1)} 0`,

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  trainerWrapper: {
    marginTop: theme.spacing(1),
  },
  trainerLabel: {},
  createForOthersRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    minWidth: 0,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1),
    },
  },
  createForOthersToggle: {
    flexShrink: 0,
  },
  createForOthersSelectWrap: {
    flex: 1,
    minWidth: 0,
  },
}));
